import React from 'react'
import { PostHogProvider } from 'posthog-js/react'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Login from './components/Login'
import NotInvited from './components/NotInvited'
import ConfigurationMissing from './components/ConfigurationMissing'
import App from './App'
import { supabase } from './lib/supabase'
import CircularLoader from './components/CircularLoader'

const AuthenticatedApp: React.FC = () => {
  const { user, loading, notInvited, retryAuth } = useAuth()

  if (loading) {
    return <CircularLoader size="large" fullscreen />
  }

  if (notInvited?.show) {
    return <NotInvited email={notInvited.email} onRetry={retryAuth} />
  }

  if (!user) {
    return <Login />
  }

  return <App />
}

const AppWrapper: React.FC = () => {
  // If Supabase is not configured, show configuration screen
  if (!supabase) {
    return <ConfigurationMissing />
  }

  // Check if PostHog is configured
  const posthogApiKey = process.env.REACT_APP_POSTHOG_KEY
  const posthogHost = process.env.REACT_APP_POSTHOG_HOST

  // If PostHog is not configured, render without PostHog
  if (!posthogApiKey) {
    return (
      <AuthProvider>
        <AuthenticatedApp />
      </AuthProvider>
    )
  }

  // If PostHog is configured, render with PostHog
  return (
    <PostHogProvider
      apiKey={posthogApiKey}
      options={{
        api_host: posthogHost,
        defaults: '2025-05-24',
        capture_exceptions: true, // enable exception tracking
        debug: process.env.NODE_ENV === 'development'
      }}
    >
      <AuthProvider>
        <AuthenticatedApp />
      </AuthProvider>
    </PostHogProvider>
  )
}

export default AppWrapper
